function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var VideocamOff = function VideocamOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: props === null || props === void 0 ? void 0 : props.className,
    viewBox: "0 0 24 24",
    fill: "#fff",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m21 6.5-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2 2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
  }));
};

export default VideocamOff;